// export default SideBar;
import React, { useState, useEffect } from "react";
import Logo from "../../assets/FastRealtyLogo.png";
import DashBoardIcon from "../../assets/dashboardIcon.png";
import ConciergeAgentIcon from "../../assets/conciergeAgentIcon.png";
import DownArrowIcon from "../../assets/downArrowIcon.png";
import SettingsIcon from "../../assets/settings.png";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import myProfileIcon from "../../assets/myProfile.png";
import LogOutIcon from "../../assets/exit.png";
import { Auth } from "aws-amplify";
import { apiFetch } from "../../../../utils/apiFetch";
import { useDispatch } from "react-redux";
import { addToken } from "../../../../actions/addToken";
import { clearHostedUiToken } from "../../../../utils/hostedUiToken";
import RightArrow from "../../assets/rightArrow.png";
import { useHistory, useLocation } from "react-router-dom";

const SideBar = ({ onClose }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isConciergeOpen, setConciergeOpen] = useState(false);
  const [isRentalManagerOpen, setRentalManagerOpen] = useState(false);
  const [isStaff, setIsStaff] = useState(false);

  const isActive = (path) => location.pathname === path;

  const signOut = async () => {
    try {
      await Auth.signOut();
      console.log("logout successful");
      localStorage.removeItem("token");
      clearHostedUiToken();
      dispatch(addToken(null));
      history.push("./");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  const handleDashbard = () => {
    history.push("/dashboard");
  };

  useEffect(() => {
    // Check if user has staff permissions
    const checkStaffStatus = async () => {
      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/me`
        );
        if (response.ok) {
          const data = await response.json();
          setIsStaff(data.is_staff || false);
        }
      } catch (error) {
        console.error("Error checking staff status:", error);
      }
    };

    checkStaffStatus();
  }, []);

  useEffect(() => {
    // Automatically open section based on current route
    if (location.pathname === "/concierge") {
      setConciergeOpen(true);
    } else if (location.pathname === "/rental-properties") {
      setRentalManagerOpen(true);
    }
  }, [location.pathname]);

  const activeStyle = {
    color: "#28a382",
    borderLeft: "3px solid #28a382",
    backgroundColor: "#f9f9f9",
  };

  return (
    <div className="sideBar-container">
      <div className="sideBar-top">
        <div className="sideBar-logo">
          <img src={Logo} alt="logo" className="sb-logo" />
          <img
            src={RightArrow}
            alt="right-arrow"
            className="right-arrow"
            onClick={onClose} // 🔥 This closes the sidebar
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="sideBar-content-container">
          {/* Dashboard */}
          <div
            className="dashboard-s"
            style={location.pathname === "/dashboard" ? activeStyle : {}}
            onClick={handleDashbard}
          >
            <div className="ds">
              <img
                src={DashBoardIcon}
                alt="dashboard-icon"
                className="dashboard-icon"
              />
              <p>Dashboard</p>
            </div>
          </div>

          {/* Prospector Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={
                location.pathname.startsWith("/concierge") ||
                location.pathname === "/client-list"
                  ? activeStyle
                  : {}
              }
              onClick={() => setConciergeOpen(!isConciergeOpen)}
            >
              <div className="prospector-s-ls">
                <img
                  src={ConciergeAgentIcon}
                  alt="concierge-agent-icon"
                  className="prospector-icon"
                />
                <p>Deal Program Manager</p>
              </div>
              <div className="prospector-s-rs">
                <img
                  src={DownArrowIcon}
                  alt="down-arrow-icon"
                  className="down-arrow-icon"
                  style={{
                    transform: isConciergeOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>

            {(isConciergeOpen ||
              location.pathname.startsWith("/concierge") ||
              location.pathname === "/client-list") && (
              <div className="prospector-hidden">
                <p
                  className="hidden-li"
                  style={isActive("/client-list") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setConciergeOpen(true);
                    history.push("/client-list");
                  }}
                >
                  Deals
                </p>
              </div>
            )}
          </div>

          {/* Rental Manager Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={location.pathname === "/rental-properties" ? activeStyle : {}}
              onClick={() => setRentalManagerOpen(!isRentalManagerOpen)}
            >
              <div className="prospector-s-ls">
                <HomeWorkIcon
                  aria-label="rental-manager-icon"
                  className="prospector-icon"
                />
                <p>Rental Manager</p>
              </div>
              <div className="prospector-s-rs">
                <img
                  src={DownArrowIcon}
                  alt="down-arrow-icon"
                  className="down-arrow-icon"
                  style={{
                    transform: isRentalManagerOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>

            {(isRentalManagerOpen || location.pathname === "/rental-properties") && (
              <div className="prospector-hidden">
                <p
                  className="hidden-li"
                  style={isActive("/rental-properties") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setRentalManagerOpen(true);
                    history.push("/rental-properties");
                  }}
                >
                  Properties
                </p>
              </div>
            )}
          </div>

          {/* Marketing Manager Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={location.pathname.startsWith("/marketing") ? activeStyle : {}}
              onClick={() => history.push("/marketing")}
            >
              <div className="prospector-s-ls">
                <AnnouncementIcon
                  aria-label="marketing-manager-icon"
                  className="prospector-icon"
                />
                <p>Marketing Manager</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="sideBar-bottom">
        <div className="sideBar-sp">
          <div
            className="profile"
            style={location.pathname === "/myaccount" ? activeStyle : {}}
            onClick={() => history.push("/myaccount")}
          >
            <img src={myProfileIcon} alt="profile" className="profile-icon" />
            <p>My Profile</p>
          </div>
        </div>
        {/* Admin - only visible to staff */}
        {isStaff && (
          <div
            className="profile"
            style={location.pathname.startsWith("/admin") ? activeStyle : {}}
            onClick={() => history.push("/admin/dashboard")}
          >
            <img src={SettingsIcon} alt="admin-icon" className="profile-icon" />
            <p>Admin</p>
          </div>
        )}
        <div className="lg" onClick={signOut}>
          <img src={LogOutIcon} alt="logOutIcon" className="logOut-icon" />
          <p>LogOut</p>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
